import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const PaymentApprovalList = {
    columns: [
        {
            name: "Date",
            fieldName: "amountCollectedDate",
            colType: GridColumnType.DATE,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // },
            colSettings: {
                format: "DD-MMM-YYYY"
            },
            allowShort: false,
        },
        {
            name: "Bank Information",
            fieldName: "bankName",
            allowShort: false,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // }
        },
        {
            name: "Amount Collected",
            fieldName: "amountCollected",
            allowShort: false,
            // colStyle: {
            //     width: "15%",
            //     textAlign: "center",
            //     color: "color",
            //     backgroundColor: "white"
            // }
        },
        {
            name: "Comments",
            fieldName: "comments",
            colType: GridColumnType.Text,
            allowShort: false,
            // colStyle: {
            //     width: "40%",
            //     textAlign: "center",
            //     color: "white",
            //     backgroundColor: "white"

            // }
         }
    ],
    allowEdit: false,
    isRowSelectable: true,
    hasChildGridTable: false,
    gridStyle: {
        tableClass: "border-table-simple"
    }
}